// components/Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { 
  FaBars, FaSearch, FaBell, FaEnvelope, FaUser 
} from 'react-icons/fa';
import axios from 'axios';
import { Link } from 'react-router-dom';
import io from 'socket.io-client';

const Navbar = ({ toggleSidebar }) => {
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const socket = useRef(null);

  useEffect(() => {
    // Connect to WebSocket
    socket.current = io('https://afric-fresh-backend.onrender.com:3005');

    // Listen for new messages
    socket.current.on('newMessage', (message) => {
      setNotifications(prev => [...prev, message]);
    });

    // Fetch initial unread messages
    fetchUnreadMessages();

    // Cleanup
    return () => {
      if (socket.current) {
        socket.current.disconnect();
      }
    };
  }, []);

  // Click outside to close notifications
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchUnreadMessages = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('adminToken'));

      const response = await axios.get('https://afric-fresh-backend.onrender.com/api/messages/unread',{
        headers: {
          Authorization: `Bearer ${token}`
        }},);
      setNotifications(response.data);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const handleNotificationClick = async () => {
    setShowNotifications(!showNotifications);
    
    if (notifications.length > 0) {
      try {
        // Mark all as read
        await axios.put('https://afric-fresh-backend.onrender.com/api/messages/mark-read');
        // Update local state to mark all as read
        setNotifications(prev => prev.map(notif => ({ ...notif, isRead: true })));
      } catch (error) {
        console.error('Error marking notifications as read:', error);
      }
    }
  };

  return (
    <nav className="bg-white shadow-md p-4 flex justify-between items-center relative">
      <div className="flex items-center">
        <button 
          onClick={toggleSidebar} 
          className="mr-4 text-gray-600 hover:text-blue-600"
        >
          <FaBars size={24} />
        </button>
      </div>

      <div className="flex items-center space-x-4">
        {/* <div className="relative" ref={notificationRef}>
          <button 
            onClick={handleNotificationClick}
            className="relative p-2 text-gray-600 hover:text-blue-600"
          >
            <FaBell size={24} />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                {notifications.length}
              </span>
            )}
          </button>

  
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl z-50">
              <div className="p-4 border-b">
                <h3 className="text-lg font-semibold">Notifications</h3>
              </div>
              <div className="max-h-96 overflow-y-auto">
                {notifications.length > 0 ? (
                  notifications.map((notif, index) => (
                    <Link 
                      to={`/admin/messages/${notif._id}`} 
                      key={notif._id || index}
                      className="block p-4 hover:bg-gray-50 border-b"
                    >
                      <div className="flex items-start">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                          <FaEnvelope className="text-blue-500" />
                        </div>
                        <div>
                          <p className="font-medium">{notif.name}</p>
                          <p className="text-sm text-gray-600 truncate">{notif.message}</p>
                          <p className="text-xs text-gray-400 mt-1">
                            {new Date(notif.createdAt).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="p-4 text-center text-gray-500">
                    No new notifications
                  </div>
                )}
              </div>
              <div className="p-4 border-t">
                <Link 
                  to="/admin/adminmessages"
                  className="text-blue-500 hover:text-blue-600 text-sm font-medium"
                >
                  View All Messages
                </Link>
              </div>
            </div>
          )}
        </div> */}

        <div className="flex items-center space-x-2">
          <FaUser className="text-gray-600" />
          <span>Admin User</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;